<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tutors
 * Name: TutorQuote
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3314-65
 *
 * The words of the tutor on a tinted plate: decorative quote mark + text clamped to
 * four lines (line count is the limit — never a fixed or max height; this is the block
 * that absorbs the slack inside TutorCard and keeps the CTA on the card floor).
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { TutorQuoteProps } from '../types/interfaces'
// assets
import quoteMark from '../images/quote-mark.svg'

defineOptions({
  name: 'TutorQuote',
})

defineProps<TutorQuoteProps>()
</script>

<template>
  <div class="tutor-quote">
    <img
      class="tutor-quote__mark"
      :src="quoteMark"
      alt=""
      width="30"
      height="24"
    >
    <p class="tutor-quote__text btly-text-body-l">{{ quote }}</p>
  </div>
</template>

<style lang="scss" scoped src="../styles/_tutor-quote.scss" />
